module.exports = __webpack_public_path__ + "img/spin_wheel_bg_lt.0f3172dc.png";